import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option"];

  connect() {
    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    this.onSystemChange = () => {
      if (this.stored() === "system") this.apply("system");
    };
    this.mediaQuery.addEventListener("change", this.onSystemChange);
    this.apply(this.stored());
    this.syncOptions();
  }

  disconnect() {
    this.mediaQuery?.removeEventListener("change", this.onSystemChange);
  }

  toggle() {
    const next = document.documentElement.classList.contains("dark") ? "light" : "dark";
    this.set(next);
  }

  choose(event) {
    this.set(event.currentTarget.dataset.themeValue);
  }

  set(mode) {
    localStorage.setItem("theme", mode);
    this.apply(mode);
    this.syncOptions();
    document.dispatchEvent(new CustomEvent("theme:changed", { detail: { mode } }));
  }

  stored() {
    return localStorage.getItem("theme") || "system";
  }

  apply(mode) {
    const dark = mode === "dark" || (mode === "system" && this.mediaQuery.matches);
    document.documentElement.classList.toggle("dark", dark);
    document.documentElement.style.colorScheme = dark ? "dark" : "light";
  }

  syncOptions() {
    if (!this.hasOptionTarget) return;
    const current = this.stored();
    this.optionTargets.forEach((button) => {
      const active = button.dataset.themeValue === current;
      button.classList.toggle("theme-switcher__btn--active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }
}
